import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';
import { Order } from 'shell/view-models/order';
import { ResearchMetricVM } from 'practice/view-models/research-metric';

export const transformDataset = (values: ResearchMetricVM): string => {
  const transformedFilters: OperationObject = {
    tipoRegistro: { value: values.filter?.typeRegister || '', operation: Operation.EQUALS },
    tipoPratica: {
      value: values.filter?.typePractice || '',
      operation: Operation.EQUALS,
    },
    tipoOperazione: {
      value: values.filter?.typeOperation || '',
      operation: Operation.EQUALS,
    },
    dataAttivazione: {
      value: values.filter?.dateFrom ? values.filter?.dateFrom.toFormat('yyyy-MM-dd') : '',
    },
    dataDisattivazione: {
      value: values.filter?.dateTo ? values.filter?.dateTo.toFormat('yyyy-MM-dd') : '',
    },
    codStatoPratica: {
      value: values.filter?.state || '',
      operation: Operation.EQUALS,
    },
  };

  const ordersToTransform = values.filter?.orders || {};
  const ordersMapped: Order = {
    tipoRegistro: ordersToTransform?.register,
    tipoPratica: ordersToTransform?.practice,
    dataAttivazione: ordersToTransform?.validityFrom,
    dataDisattivazione: ordersToTransform?.validityTo,
    codStatoPratica: ordersToTransform?.state,
  };

  return `${paginationListToQueryString({
    filters: transformedFilters,
    orders: ordersMapped,
  })}`;
};
